import React, { useEffect, useState } from "react";
import { Button, Modal } from "../../../../components/core";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_PARTNER,
  ID_TYPES,
  PARTNER_CATEGORY,
  PAYMENT_MODES,
  SEARCH_PARTNERS,
  UPDATE_PARTNER_PROFILE,
} from "../../../../constants/graphql/partners-query";
import { useNavigate, useParams } from "react-router-dom";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  onClearDataReducer,
  onPartnerProfileDataChange,
} from "../../../../features/partner/add-partner-slice";
import { CREATE_BRANCH } from "../../../../constants/graphql/branch-queries";
import { PARTNER_TYPE_FOR_PARTNER } from "../../../../constants/graphql/partners-query";
import useSidebarStore from "../../../../zustand/stores/sidebar-store";
import { Strings } from "../../../../constants/strings";
import PartnerProfileForm from "./partner-profile-form";
import PartnerAdminAccount from "./admin-account";
import { onPartnerProfileRender } from "../../../../features/partner/partner-profile-slice";
import PartnerWalletConfiguration from "./step-two";

const breadcrumbItems = [
  {
    label: "Partner",
    path: `/partners/`,
  },
  { label: "Partner Profile", path: "#" },
];

export const items = [
  {
    label: "Partner Profile",
  },
  {
    label: "Partner Wallet Configuration",
  },
  {
    label: "Partner Super Admin Account",
  },
];

export default function AddPartner() {
  //
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { operatorId, partnerId } = useParams();

  const partnerProfileData = useSelector(
    (state) => state.addPartner.partnerProfileData,
  );
  const accessPermissions = useSelector(
    (state) => state.accessPermissions.accessPermissions,
  );
  //Mutation and Queries
  const [createPartner] = useMutation(CREATE_PARTNER);
  const [updateCourierProfile, { data, loading, error }] = useMutation(
    UPDATE_PARTNER_PROFILE,
  );
  const [createBranch] = useMutation(CREATE_BRANCH);
  const partnerCategory = useQuery(PARTNER_CATEGORY);
  const idTypes = useQuery(ID_TYPES);
  const paymentSchedules = useQuery(PAYMENT_MODES);
  const partnerTypes = useQuery(PARTNER_TYPE_FOR_PARTNER, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      ...(partnerProfileData.partnerCategoryNo !== "-1" && {
        partnerCategoryNo: partnerProfileData.partnerCategoryNo,
      }),
    },
  });
  const searchPartner = useQuery(SEARCH_PARTNERS, {
    variables: {
      operatorId: operatorId,
      // if === "new", do not call
      partnerId: parseInt(partnerId),
    },
  });
  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation,
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);
  const { setIsPartnerAdminPage, updateActiveItems } = useSidebarStore();

  // Local States
  const [partnerTypesItems, setPartnerTypesItems] = React.useState([]);
  const [partnerCategoryItems, setPartnerCategoryItems] = React.useState([]);
  const [idTypesItem, setIdTypesItem] = React.useState([]);
  const [changesMade, setChangesMade] = useState(false);
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAlreadyExisting, setIsAlreadyExisting] = useState(false);

  const [paymentSchedulesItem, setPaymentSchedulesItem] = React.useState([]);
  const [openSaveModal, setOpenSaveModal] = React.useState(false);
  const [openCancelModal, setOpenCancelModal] = React.useState(false);
  const [createdPartner, setCreatedPartner] = useState({
    partnerId: "",
    partner: "",
    operatorId: "",
    companyNickname: "",
  });

  const contactPersonFields = [
    {
      index: 1,
      suffix: "",
      fields: {
        contactPerson: "contactPerson",
        contactPosition: "contactPosition",
        mobile: "mobile",
        email: "email",
        landline: "landline",
      },
    },
    {
      index: 2,
      suffix: "2",
      fields: {
        contactPerson: "contactPerson2",
        contactPosition: "contactPosition2",
        mobile: "mobile2",
        email: "email2",
        landline: "landline2",
      },
    },
  ];

  useEffect(() => {
    // When entering partner admin flow
    setIsPartnerAdminPage(true);
    updateActiveItems(window.location.pathname, accessPermissions);

    return () => {
      // When leaving partner admin flow
      setIsPartnerAdminPage(false);
    };
  }, []);

  useEffect(() => {
    if (partnerId !== "new") {
      if (searchPartner.data && searchPartner.data.searchCouriers[0]) {
        setIsAlreadyExisting(true);

        var searchPartnerData = searchPartner.data.searchCouriers[0];
        dispatch(onPartnerProfileRender(searchPartnerData));
      }
    }
  }, [searchPartner.data]);

  // Use Effects
  React.useEffect(() => {
    if (partnerCategory.data) {
      var tempArr = [];
      partnerCategory.data.partnerCategories.forEach((element) => {
        tempArr.push({
          value: element.partnerCategoryNo,
          name: element.partnerCategory,
        });
      });
      setPartnerCategoryItems(tempArr);
    }
  }, [partnerCategory.data]);
  React.useEffect(() => {
    if (partnerTypes.data) {
      // searchPartner.data.partners[0].partnerType.partnerCategory.partnerCategory
      var tempArr = [];
      partnerTypes.data.partnerTypes.forEach((element) => {
        tempArr.push({
          value: element.partnerTypeId,
          name: element.partnerType,
        });
      });
      setPartnerTypesItems(tempArr);
    }
  }, [partnerTypes.data]);
  React.useEffect(() => {
    if (idTypes.data) {
      var tempArr = [];
      idTypes.data.idTypes.forEach((element) => {
        tempArr.push({
          value: element.idTypeId,
          label: element.idType,
        });
      });
      setIdTypesItem(tempArr);
    }
  }, [idTypes.data]);
  React.useEffect(() => {
    if (paymentSchedules.data) {
      var tempArr = [];
      paymentSchedules.data.paymentSchedules.forEach((element) => {
        tempArr.push({
          value: element.paymentScheduleNo,
          name: element.paymentSchedule,
        });
      });
      setPaymentSchedulesItem(tempArr);
    }
  }, [paymentSchedules.data]);

  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  // window.location.reload();
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  const handleOnChange = (event) => {
    const { name, value, checked } = event.target;

    if (
      name === "tinNumber" ||
      name === "zipCode" ||
      name === "mobile" ||
      name === "mobile2" ||
      name === "landline" ||
      name === "landline2"
    ) {
      // const tinRegex = /^\d+$/;
      const tinRegex = /^\d*$/;

      if (!tinRegex.test(value)) {
        setChangesMade(false);
        return; // Exit if the validation fails
      }
    }

    // Refetch partner types for partnerCategoryNo
    if (name === "partnerCategoryNo") {
      partnerTypes.refetch({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        partnerCategoryNo: value,
      });
    }

    // Dispatch the change
    dispatch(onPartnerProfileDataChange({ name, value, checked }));
    setChangesMade(true);
  };

  const handleCancelChanges = () => {
    dispatch(onClearDataReducer());
    // console.log(partnerProfileData.address);
    // setOpenCancelModal(false);
    navigate(`/partners`);
  };

  const showValidationError = (message) => {
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
      title: Strings.popup_error_title,
      message,
      open: true,
      actions: (
        <div className="grid grid-cols-1 gap-2">
          <Button
            value={"OK"}
            className={"p-2"}
            onClick={() => setValidation(false)}
          />
        </div>
      ),
    });
  };

  const goToNextStep = (createdPartnerId) => {
    // If we're on the last page (Admin Account), reload
    if (activeIndex === 2) {
      window.location.reload();
      return;
    }

    // Update URL when partner is created (moving from step 0 to 1)
    if (activeIndex === 0 && createdPartnerId) {
      // Update URL and set activeIndex to 1
      navigate(`/partners/add-profile/${operatorId}/${createdPartnerId}`, {
        replace: true,
      });
      setActiveIndex(1);
      return; // Early return to prevent further execution
    }

    // Move to next step for other cases
    setActiveIndex((prevStep) => prevStep + 1);
  };

  const buildMutationVariables = () => {
    const updatedVariables = {
      operatorId: operatorId,
      featuresCod: partnerProfileData.featuresCod,
      featuresShipout: partnerProfileData.featuresShipout,
      featuresReturns: partnerProfileData.featuresReturns,
      agentTopupAmount: partnerProfileData.agentTopupAmount,
      agentTopupThreshold: partnerProfileData.agentTopupThreshold,
    };

    if (partnerProfileData.partnerTypeId !== "-1") {
      updatedVariables.partnerTypeId = partnerProfileData.partnerTypeId;
    }

    if (partnerProfileData.partnerId !== "") {
      updatedVariables.partnerId = partnerProfileData.partnerId;
    }

    if (partnerProfileData.partnerCategoryNo !== "-1") {
      updatedVariables.partnerCategoryNo = partnerProfileData.partnerCategoryNo;
    }

    if (partnerProfileData.companyNickname !== "") {
      updatedVariables.companyNickname = partnerProfileData.companyNickname;
    }

    if (partnerProfileData.tinNumber !== "") {
      updatedVariables.tinNumber = partnerProfileData.tinNumber;
    }

    if (partnerProfileData.address !== "") {
      updatedVariables.address = partnerProfileData.address;
    }

    if (partnerProfileData.zipCode !== "") {
      updatedVariables.zipCode = partnerProfileData.zipCode;
    }
    if (partnerProfileData.address !== "") {
      updatedVariables.address = partnerProfileData.address;
    }
    if (partnerProfileData.contactPerson !== "") {
      updatedVariables.contactPerson = partnerProfileData.contactPerson;
    }
    if (partnerProfileData.contactPerson2 !== "") {
      updatedVariables.contactPerson2 = partnerProfileData.contactPerson2;
    }
    if (partnerProfileData.contactPosition !== "") {
      updatedVariables.contactPosition = partnerProfileData.contactPosition;
    }
    if (partnerProfileData.contactPosition2 !== "") {
      updatedVariables.contactPosition2 = partnerProfileData.contactPosition2;
    }

    if (partnerProfileData.mobile !== "") {
      updatedVariables.mobile = partnerProfileData.mobile;
    }
    if (partnerProfileData.mobile2 !== "") {
      updatedVariables.mobile2 = partnerProfileData.mobile2;
    }
    if (partnerProfileData.landline !== "") {
      updatedVariables.landline = partnerProfileData.landline;
    }
    if (partnerProfileData.landline2 !== "") {
      updatedVariables.landline2 = partnerProfileData.landline2;
    }
    if (partnerProfileData.email !== "") {
      updatedVariables.email = partnerProfileData.email;
    }

    if (partnerProfileData.email2 !== "") {
      updatedVariables.email2 = partnerProfileData.email2;
    }
    if (partnerProfileData.paymentScheduleNo !== "") {
      updatedVariables.paymentScheduleNo = partnerProfileData.paymentScheduleNo;
    }

    if (partnerProfileData.statusComments !== "") {
      updatedVariables.statusComments = partnerProfileData.statusComments;
    }
    if (partnerProfileData.remarks !== "") {
      updatedVariables.remarks = partnerProfileData.remarks;
    }
    if (
      partnerProfileData.agentTopupSourceNo !== "-1" ||
      partnerProfileData.agentTopupSourceNo !== -1
    ) {
      let derivedTopUpSource =
        partnerProfileData.agentTopupSourceNo === -2
          ? 0
          : parseInt(partnerProfileData.agentTopupSourceNo);

      updatedVariables.agentTopupSourceNo = derivedTopUpSource;
    }

    // agentSourceFundNo intentionally omitted: agent_fund_source_no column
    // does not exist on the live database yet.
    // updatedVariables.agentSourceFundNo = parseInt(
    //   partnerProfileData.agentSourceFundNo ?? 0,
    // );

    return updatedVariables;
  };

  const handleSaveChanges = () => {
    // const idsArr = partnerProfileData.ids.map((element) => element.value);
    // const updatedData = {
    //   ...partnerProfileData,
    //   agentTopupSourceNo:
    //     partnerProfileData.agentTopupSourceNo === -2
    //       ? 0
    //       : parseInt(partnerProfileData.agentTopupSourceNo),
    //   // landline: partnerProfileData.landline.replaceAll("-", ""),
    //   // landline2: partnerProfileData.landline2.replaceAll("-", ""),
    //   // tinNumber: partnerProfileData.tinNumber.replaceAll("-", ""),
    //   // ids: idsArr,
    // };
    const variables = buildMutationVariables();

    // if active index === 1, always call update instead of create
    if (activeIndex !== 1) {
      createPartner({ variables: { couriers: [variables] } })
        .then((data) => {
          if (data.data) {
            const partnerId = data.data.createCourier.courierProfile.partnerId;
            const operatorId = JSON.parse(
              localStorage.getItem("user"),
            ).operator_id;

            // autocreate branch with branch level automatically set as head office
            createBranch({
              variables: {
                branches: [
                  {
                    operatorId: JSON.parse(localStorage.getItem("user"))
                      .operator_id,
                    partnerId: partnerId,
                    partnerBranch: `${variables.companyNickname}`,
                    branchLevel: 0,
                    address: variables.address,
                    zipCode: variables.zipCode,
                    contactPerson: variables.contactPerson,
                    contactPerson2: variables.contactPerson,
                    contactPosition: variables.contactPerson,
                    contactPosition2: variables.contactPerson,
                    landline: variables.landline,
                    landline2: variables.landline2,
                    mobile: "63" + variables.mobile,
                    mobile2: "63" + variables.mobile2,
                    email: variables.email,
                    email2: variables.email2,
                    remarks: "",
                  },
                ],
              },
            })
              .then((data) => {
                setCreatedPartner({
                  ...createdPartner,
                  operatorId: operatorId,
                  partnerId: partnerId,
                });
                setValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                  title: "Success",
                  message: "Successfully added a partner.",
                  open: true,
                  actions: (
                    <div className="grid grid-cols-1 gap-2">
                      <Button
                        value={"OK"}
                        className={"p-2"}
                        onClick={() => {
                          setValidation({ open: false });

                          goToNextStep(partnerId);
                        }}
                      />
                    </div>
                  ),
                });
                dispatch(onClearDataReducer());
              })
              .catch((e) => {});
          }
        })
        .catch((e) => {
          if (e.message.includes("duplicate")) {
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: Strings.popup_error_title,
              message: Strings.popup_error_message_duplicate,
              open: true,
              actions: (
                <div className="grid grid-cols-1 gap-2">
                  <Button
                    value={"OK"}
                    className={"p-2"}
                    onClick={() => setValidation(false)}
                  />
                </div>
              ),
            });
          } else {
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: Strings.popup_error_title,
              message: Strings.popup_error_message_add,
              open: true,
              actions: (
                <div className="grid grid-cols-1 gap-2">
                  <Button
                    value={"OK"}
                    className={"p-2"}
                    onClick={() => setValidation(false)}
                  />
                </div>
              ),
            });
          }
        });
    } else {
      delete variables.walletBalance;

      updateCourierProfile({
        variables: {
          couriers: [{ ...variables, partnerId }],
        },
      })
        .then((data) => {
          searchPartner
            .refetch({
              operatorId: localStorage.getItem("user")
                ? JSON.parse(localStorage.getItem("user")).operator_id
                : "",
              partnerId: parseInt(partnerId),
            })
            .then((data) => {
              var searchPartnerData = data.data.searchCouriers[0];
              dispatch(onPartnerProfileRender(searchPartnerData));
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                title: Strings.popup_success_title_default,
                message: Strings.popup_success_message_add,
                open: true,
                actions: (
                  <div className="grid grid-cols-1 gap-2">
                    <Button
                      onClick={() => {
                        setValidation({ open: false });
                        goToNextStep(partnerId);
                      }}
                      value={"OK"}
                      className={"p-2"}
                    />
                  </div>
                ),
              });
            });
        })
        .catch((e) => {
          const isDuplicate = e.message.includes("duplicate");
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: isDuplicate
              ? Strings.popup_error_message_duplicate
              : Strings.popup_error_message_edit,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  value={"OK"}
                  className={"p-2"}
                  onClick={() => setValidation(false)}
                />
              </div>
            ),
          });
        });
    }
    // }
  };

  const handleResetFeatures = () => {
    // Reset all feature checkboxes to unchecked (0)
    const featureFields = ["featuresCod", "featuresShipout", "featuresReturns"];

    featureFields.forEach((fieldName) => {
      dispatch(
        onPartnerProfileDataChange({
          name: fieldName,
          value: 0,
          checked: false,
        }),
      );
    });

    setChangesMade(true);
  };

  // TODO: fix this :>
  useEffect(() => {
    // Only set activeIndex to 2 if partner already exists AND we're starting fresh (activeIndex is 0)
    if (isAlreadyExisting && activeIndex === 0) {
      setActiveIndex(2);
    }
  }, [isAlreadyExisting]);

  console.log({ partnerProfileData, activeIndex });
  return (
    <>
      {/* <Breadcrumbs items={breadcrumbItems} /> */}
      <div className="w-full mb-8 px-20">
        {" "}
        {/* Outer container with padding */}
        <div className="flex items-center justify-between relative">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center flex-1 relative"
            >
              {/* Connecting Line - only between steps */}
              {index < items.length - 1 && (
                <div
                  className={`absolute top-6 left-1/2 w-full h-0.5 z-0 ${
                    index < activeIndex ? "bg-blue-500" : "bg-gray-300"
                  }`}
                />
              )}

              {/* Step Circle */}
              <div className="relative z-10 flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-lg font-semibold transition-all ${
                    index <= activeIndex
                      ? "bg-blue-500 text-white"
                      : "bg-gray-300 text-gray-600"
                  }`}
                >
                  {index + 1}
                </div>
                <div
                  className={`mt-2 text-sm font-medium text-center ${
                    index <= activeIndex ? "text-gray-900" : "text-gray-400"
                  }`}
                >
                  {item.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {activeIndex === 0 ? (
        <PartnerProfileForm
          isEditing={false}
          isAlreadyExisting={isAlreadyExisting}
          partnerProfileData={partnerProfileData}
          partnerCategoryItems={partnerCategoryItems}
          partnerTypesItems={partnerTypesItems}
          contactPersonFields={contactPersonFields}
          paymentSchedulesItem={paymentSchedulesItem}
          changesMade={changesMade}
          accessPermission={accessPermissions}
          handleOnChange={handleOnChange}
          handleResetFeatures={handleResetFeatures}
          handleSaveChanges={handleSaveChanges}
          handleCancelChanges={handleCancelChanges}
          setValidation={setValidation}
          setActiveIndex={setActiveIndex}
          partnerId={partnerId}
        />
      ) : activeIndex === 1 ? (
        <PartnerWalletConfiguration
          partnerProfileData={partnerProfileData}
          handleOnChange={handleOnChange}
          accessPermission={accessPermissions}
          changesMade={changesMade}
          isAlreadyExisting={isAlreadyExisting}
          handleCancelChanges={handleCancelChanges}
          handleSaveChanges={handleSaveChanges}
          setValidation={setValidation}
          goToNextStep={goToNextStep}
          setActiveIndex={setActiveIndex}
        />
      ) : (
        <>
          {/* TODO: pass the created data details + make the mutation work */}
          <PartnerAdminAccount setActiveIndex={setActiveIndex} />
        </>
      )}
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </>
  );
}
